export default __webpack_public_path__ + "navigation-examples-custom-server-1200-1b978043eed51723fee7db3739e4bbfe.webp";